import type {IconSize, IconType} from '@Components/icon-v2/icon.types';

export type AccordionHeaderOpts = {
  /**
   * the padding for the main container of the accordion header. Default: ACCORDION_HEADER_SPACING.MEDIUM
   */
  headerPadding?: AccordionHeaderSpacing;
  /**
   * extra classes given to the header wrapper
   */
  headerClassName?: string;
  /**
   * when true, removes the hover background from the header only while the accordion is open (the
   * closed state keeps its hover). For removing it in every state, use removeHeaderHoverStateAlways.
   */
  removeHeaderHoverStateWhenOpen?: boolean;
  /**
   * when true, renders the header without any styles: no background, no hover background, no corner radius
   */
  hasUnstyledHeader?: boolean;
  /**
   * when true, removes the hover background from the header in every state (open and closed).
   * Supersedes removeHeaderHoverStateWhenOpen.
   */
  removeHeaderHoverStateAlways?: boolean;
};

export type AccordionIconOpts = {
  /**
   * extra classes given to the icon
   */
  iconClassName?: string;
  /**
   * the size of the icon, default: IconSize.SIZE_ICON_24
   */
  iconSize?: IconSize;
  /**
   * the type of icon used, default: IconType.GHOST
   */
  iconType?: IconType;
};

export enum AccordionHeaderSpacing {
  XSMALL = 'spacing-p-2',
  SMALL = 'spacing-p-3',
  MEDIUM = 'spacing-p-4',
  LARGE = 'spacing-p-5',
  CUSTOM = '',
}
